import cn from 'classnames';
import React, { memo, ReactNode, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import Text from 'components/atoms/text';
import BackButton from 'components/organisms/backButton';
import useBackRoute from 'hooks/useBackRoute';

import sm from './styles.module.scss';

interface Props {
  title?: string;
  renderTitleInfo?: ReactNode;
  description?: string;
  cameFrom?: string;
  onBackClick?: EmptyArgsVoidFunc;
  backLabel: string;
  withGreyColorDescription?: boolean;
  renderButtons?: ReactNode;
}

type HandleBackClick = EmptyArgsVoidFunc;

const DetailsHeader = ({
  title,
  renderTitleInfo,
  description,
  cameFrom = '',
  backLabel,
  withGreyColorDescription,
  renderButtons,
  onBackClick,
}: Props) => {
  // region *******************************DATA*********************************
  const backRoute: string = useBackRoute({
    backUri: cameFrom,
  });

  const history = useHistory();
  // endregion

  // region *****************************CALLBACKS******************************
  const handleBackClick: HandleBackClick = useCallback(() => {
    history.push(backRoute || cameFrom);
  }, [backRoute, cameFrom, history]);
  // endregion

  // region ********************************JSX*********************************
  return (
    <div className={sm.Container}>
      <BackButton onClick={onBackClick || handleBackClick} label={backLabel} />
      {!!title && (
        <div
          className={cn([sm.Container_Header], {
            [sm.WithSmallerMargin]: description,
          })}
        >
          <div
            className={cn(sm.Container_TitleWrapper, {
              [sm.TitleWrapperExtra]: !!renderTitleInfo,
            })}
          >
            <Text content={title} withSemiBoldWeight with36Font />
            {renderTitleInfo}
          </div>
          <div className={sm.Container_Buttons}>{renderButtons}</div>
        </div>
      )}
      {!!description && (
        <div
          className={cn([sm.WithSmallerMargin, sm.Container_HeaderTextWrapper])}
        >
          <Text
            content={description}
            withGreyColor={withGreyColorDescription}
          />
        </div>
      )}
    </div>
  );
  // endregion
};

export default memo(DetailsHeader);
